import React, {Component, useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import {
    ColumnMenuModule,
    ColumnsToolPanelModule,
    ContextMenuModule,
    CsvExportModule,
    ExcelExportModule,
    SetFilterModule,
} from "ag-grid-enterprise";
import {AllCommunityModule, ClientSideRowModelModule} from "ag-grid-community";
import {Helmet} from "react-helmet";
import {defaultZenGroupColumnInitWithOptionsWithValueGetter} from "../../utils/zenGroupDisplayNameGridHelper";

import {
    getColumnModeInSession,
    getDefaultAgGridSidebarProps,
    getUseColumnStateInSession,
    getUseFilterStateInSession,
    onColumnStateChangedHelper,
    onFilterChangedHelper,
    onGridReadyHelper,
    onGridReadyHelperForColumnState,
    updateColumnModeInSessionHelper,
    updateUseColumnStateHelper,
    updateUseFilterStateHelper
} from "../../utils/gridFilterStateAndColumnStateHelper";
import {ClearRefresh} from "../../components/clearRefreshButtons";
import CustomNameCellEditor from "../../utils/customCellEditor";
import DTPicker from "../../utils/DTPicker";
import {GridColumnFilterStateSaving} from "../../components/columnfilterComponent";
import {
    loadDataWithSSEAndStartChangeStreamListener,
    standardHandleInsertEvent,
    standardHandlePopulateGrid,
    standardHandleUpdateAndReplaceEvent
} from "../../utils/sseAndChangeStreamHelper";
import privatePageHeaderHelper from "../../utils/privatePageHeaderHelper";
import {standardExcelExportHelper, standardExcelExportObjectInContextMenu} from "../../utils/excelExportHelper";
import {handleGroupColumnChangeNameOnly} from "../../utils/gridCellEditing";
import {useForm} from "react-hook-form";

import {
    MuiAutocompleteForZenGroupsWithoutCreateGroupOption,
    MuiAutocompleteNonGroupOptions,
    MuiCloseIconButton,
    MuiIconButtonWithTooltipAndBox, MuiIconWithTooltip
} from "../../components/muiComponents";
import {ClickToShowColumnOptionsWithToggleButtonGroup, customColumnModeText} from "../../components/clickToShowButtons";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import Modal from "react-modal";
import {getZenGroupDropDownContents} from "../../utils/zenGroupSessionStorageManager";
import {Button, FormControlLabel, Switch, ThemeProvider} from "@mui/material";
import {buttonTheme, switchTheme} from "../../utils/muiStyling";
import NotificationManager from "react-notifications/lib/NotificationManager";
import {deleteAIFirewallPolicy, setAIFirewallPolicies} from "../api/aiManagementApi";
import DeleteIcon from "@mui/icons-material/Delete";
import {DisplayOptions} from "../../components/displayOptionsComponent";
import {useOutletContext} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

let gridColumnStateSessionVariableName = "aiManagementGridColumnState"
let gridFilterStateSessionVariableName = "aiManagementGridFilterState"

const aiProtectionTypes = [
    {
        value: "BLOCK_USER_DESKTOPS",
        label: "Block User Desktops",
    },
    {
        value: "BLOCK_USER_DOCUMENTS",
        label: "Block User Documents",
    },
    {
        value: "BLOCK_USER_DOWNLOADS",
        label: "Block User Downloads",
    },
    {
        value: "BLOCK_ALL_USERS_DIRS",
        label: "Block All Users Dirs",
    },
    {
        value: "BLOCK_NETWORK_SHARES",
        label: "Block Network Shares",
    },
    {
        value: "BLOCK_NON_C_DRIVES",
        label: "Block Non C Drives",
    },
]

const reportModeEnforceBothText = "Enforce on Desktop Program and Browser"
const reportModeEnforceDesktopText = "Only Enforce Policy on Desktop Program"
const reportModeEnforceBrowserText = "Only Enforce Policy on Browser"
const reportModeFollowGroupText = "Always Follow the Group Report Mode Setting"
const reportModeAlwaysNotifyText = "Always Notify/Simulate"
const reportModeAlwaysBlockText = "Always Block"

export default function AiManagement() {
    const { isLoading, setIsLoading } = useOutletContext();
    const [gridApi, setGridApi] = useState(null);
    const { register, handleSubmit, reset } = useForm();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [createAIZenGroupSelected, setCreateAIZenGroupSelected] = useState(null);
    const [aiFirewallVariantSelected, setAiFirewallVariantSelected] = useState(null);
    const [aiFirewallReportModeSelected, setAiFirewallReportModeSelected] = useState(reportModeFollowGroupText);
    const [aiToolEnforcement, setAiToolEnforcement] = useState(reportModeEnforceBothText);
    const [aiProtectionsChecked, setAiProtectionsChecked] = useState([]);
    const [aiPreventUsageToggled, setAiPreventUsageToggled] = useState(false);
    const [useFilterStateSettingToggled, setUseFilterStateSettingToggled] = useState(getUseFilterStateInSession(gridFilterStateSessionVariableName));
    const [useColumnStateSettingToggled, setUseColumnStateSettingToggled] = useState(getUseColumnStateInSession(gridColumnStateSessionVariableName));
    const [sseDataPullActive, setSSEDataPullActive] = useState(true);
    const [enableButtons, setEnableButtons] = useState(false);
    const [asyncTransactionWaitMillis, setAsyncTransactionWaitMillis] = useState(200); //200 to start for the initial sse data pull, will change when sse data pull is done for change streams
    const [columnMode, setColumnMode] = useState(getColumnModeInSession(gridColumnStateSessionVariableName));

    // eslint-disable-next-line no-unused-vars
    const [columnDefs, setColumnDefs] = useState([
        defaultZenGroupColumnInitWithOptionsWithValueGetter(true,true, true),
        { field: "aiFirewallVariant", headerName: "AI Variant", initialWidth: 300, filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                values: ["Copilot", "ChatGPT", "Claude", "Genspark", "Comet", "Maxathon"],
                suppressSorting: false,
                convertValuesToStrings: true
            },
            valueGetter: (params) => { //need valueGetter or else true/false will show for this column in excel export because only valueGetters are used to get values for export
                if(params.node.data.aiFirewallVariant === "COPILOT"){
                    return "Copilot";
                }
                else if(params.node.data.aiFirewallVariant === "CHAT_GPT"){
                    return "ChatGPT";
                }
                else if(params.node.data.aiFirewallVariant === "CLAUDE"){
                    return "Claude";
                }
                else if(params.node.data.aiFirewallVariant === "GENSPARK"){
                    return "Genspark";
                }
                else if(params.node.data.aiFirewallVariant === "COMET"){
                    return "Comet";
                }
                else if(params.node.data.aiFirewallVariant === "MAXATHON"){
                    return "Maxathon";
                }

                else{
                    return params.node.data.aiFirewallVariant;
                }
            },
            sortable: true
        },
        { field: "aiFirewallProtection", headerName: "Protection Policy", initialWidth: 315, filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                values: [
                    "Block User Desktops",
                    "Block User Documents",
                    "Block User Downloads",
                    "Block All User Directories",
                    "Block Network Shares",
                    "Block Non C Drives",
                    "Prevent AI Variant Process From Running"
                ],
                suppressSorting: false,
                convertValuesToStrings: true
            },
            valueGetter: (params) => { //need valueGetter or else true/false will show for this column in excel export because only valueGetters are used to get values for export
                if(params.node.data.aiFirewallProtection === "BLOCK_USER_DESKTOPS"){
                    return "Block User Desktops";
                }
                else if(params.node.data.aiFirewallProtection === "BLOCK_USER_DOCUMENTS"){
                    return "Block User Documents"
                }
                else if(params.node.data.aiFirewallProtection === "BLOCK_USER_DOWNLOADS"){
                    return "Block User Downloads"
                }
                else if(params.node.data.aiFirewallProtection === "BLOCK_ALL_USERS_DIRS"){
                    return "Block All User Directories"
                }
                else if(params.node.data.aiFirewallProtection === "BLOCK_NETWORK_SHARES"){
                    return "Block Network Shares"
                }
                else if(params.node.data.aiFirewallProtection === "BLOCK_NON_C_DRIVES"){
                    return "Block Non C Drives"
                }
                else if(params.node.data.aiFirewallProtection === "PREVENT_USAGE"){
                    return "Prevent AI Variant Process From Running"
                }
                else{
                    return params.node.data.aiFirewallProtection;
                }
            },
            sortable: true
        },
        { field: "policyReportMode", headerName: "Report Mode", initialWidth: 360, filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                values: [reportModeFollowGroupText, reportModeAlwaysBlockText, reportModeAlwaysNotifyText],
                suppressSorting: true,
                convertValuesToStrings: true,
                showTooltips: true
            },
            valueGetter: (params) => { //need valueGetter or else true/false will show for this column in excel export because only valueGetters are used to get values for export
                if(params.node.data.policyReportMode === null || params.node.data.policyReportMode === undefined || params.node.data.policyReportMode === "followGroupSetting"){
                    return reportModeFollowGroupText
                }
                else if(params.node.data.policyReportMode === "onlyNotify"){
                    return reportModeAlwaysNotifyText
                }
                else if(params.node.data.policyReportMode === "onlyBlock"){
                    return reportModeAlwaysBlockText
                }
                else{
                    return params.node.data.policyReportMode;
                }
            },
            sortable: true
        },
        { field: "aiToolAction", headerName: "AI Tool Enforcement", initialWidth: 360, filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                values: [reportModeEnforceBothText, reportModeEnforceDesktopText, reportModeEnforceBrowserText],
                suppressSorting: true,
                convertValuesToStrings: true,
                showTooltips: true
            },
            valueGetter: (params) => { //need valueGetter or else true/false will show for this column in excel export because only valueGetters are used to get values for export
                if(params.node.data.aiToolAction === null || params.node.data.aiToolAction === undefined || params.node.data.aiToolAction === "both"){
                    return reportModeEnforceBothText
                }
                else if(params.node.data.aiToolAction === "onlyDesktop"){
                    return reportModeEnforceDesktopText
                }
                else if(params.node.data.aiToolAction === "onlyBrowser"){
                    return reportModeEnforceBrowserText
                }
                else{
                    return params.node.data.aiToolAction;
                }
            },
            sortable: true
        },
    ])
    const [defaultColDef, setDefaultColDef] = useState(
        {
            resizable: true,
            filterParams: null,
            floatingFilter: true,
            headerClass: "border-0 border-b-0",
            cellClass: "outline:none",
            enableCellChangeFlash: true,
            autoHeight: false,
            cellDataType: false //disable inferring cell data type automatically, can be overridden in individual colDef
        }
    )

    const sideBar = useMemo(() => {
        //Inside useMemo to help prevent the sidebar from re-rendering
        return getDefaultAgGridSidebarProps()
    }, []);
    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            enableClickSelection: true,
            checkboxes: false,
            headerCheckbox: false
        };
    }, []);

    const createAIManagementRule = (data) => {
        if(createAIZenGroupSelected === null || createAIZenGroupSelected === undefined){
            NotificationManager.info("You must select a group");
            return
        }
        if(aiFirewallVariantSelected === null || aiFirewallVariantSelected === undefined){
            NotificationManager.info("You must select a variant");
            return
        }
        //Check for prevent usage before checking ai protections length
        if(!aiPreventUsageToggled && (aiProtectionsChecked === null || aiProtectionsChecked === undefined || aiProtectionsChecked.length < 1)){
            NotificationManager.info("You must select at least one protection");
            return
        } //else aiPreventUsageToggled is true and don't need to check aiProtectionsChecked length

        //Check report mode not null
        if(aiFirewallReportModeSelected === null || aiFirewallReportModeSelected === undefined){
            NotificationManager.info("You must select a report mode");
            return
        }
        //check ai tool enforcement not null
        if(aiToolEnforcement === null || aiToolEnforcement === undefined){
            NotificationManager.info("You must select an enforcement");
            return
        }

        let aiVariantValueToSend = aiFirewallVariantSelected
        if(aiVariantValueToSend === "Copilot"){ //format for api
            aiVariantValueToSend = "COPILOT"
        }
        else if(aiVariantValueToSend === "ChatGPT"){
            aiVariantValueToSend = "CHAT_GPT"
        }
        else if(aiVariantValueToSend === "Claude"){
            aiVariantValueToSend = "CLAUDE"
        }
        else if(aiVariantValueToSend === "Genspark"){
            aiVariantValueToSend = "GENSPARK"
        }
        else if(aiVariantValueToSend === "Comet"){
            aiVariantValueToSend = "COMET"
        }
        else if(aiVariantValueToSend === "Maxathon"){
            aiVariantValueToSend = "MAXATHON"
        }
        //passed checks, good to send request. Format the map to send
        let policiesMap = new Map()
        policiesMap.set(aiVariantValueToSend, aiProtectionsChecked)
        let policies = Object.fromEntries(policiesMap);

        //prep report mode to send
        let reportModeValueToSend = aiFirewallReportModeSelected
        if(reportModeValueToSend === reportModeFollowGroupText){
            reportModeValueToSend = "followGroupSetting"
        }
        else if(reportModeValueToSend === reportModeAlwaysNotifyText){
            reportModeValueToSend = "onlyNotify"
        }
        else if(reportModeValueToSend === reportModeAlwaysBlockText){
            reportModeValueToSend = "onlyBlock"
        }
        //prep ai tool enforcement to send
        let aiToolEnforcementValueToSend = aiToolEnforcement
        if(aiToolEnforcementValueToSend === reportModeEnforceBothText){
            aiToolEnforcementValueToSend = "both"
        }
        else if(aiToolEnforcementValueToSend === reportModeEnforceDesktopText){
            aiToolEnforcementValueToSend = "onlyDesktop"
        }
        else if(aiToolEnforcementValueToSend === reportModeEnforceBrowserText){
            aiToolEnforcementValueToSend = "onlyBrowser"
        }

        setIsLoading(true)
        setAIFirewallPolicies(createAIZenGroupSelected, policies, aiPreventUsageToggled, reportModeValueToSend, aiToolEnforcementValueToSend).then(response => {
            setIsLoading(false)
            NotificationManager.success("Successfully created AI Management Rule");
            resetCreateModal()
        }).catch(error => {
            if(error.message){
                NotificationManager.error(error.message);
            }
            else{
                NotificationManager.error("Unexpected error making this request");
            }
            setIsLoading(false)
        })
    };


    function resetCreateModal(){
        setModalIsOpen(false)
        setCreateAIZenGroupSelected(null)
        setAiFirewallVariantSelected(null)
        setAiFirewallReportModeSelected(reportModeFollowGroupText)
        setAiToolEnforcement(reportModeEnforceBothText)
        setAiPreventUsageToggled(false)
        setAiProtectionsChecked([])
        reset({})
    }
    return (
        <div className="flex flex-col h-full">
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <title>AI Privacy Management</title>
                <script src="https://js.stripe.com/v3/"/>
                <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap" rel="stylesheet"/>
            </Helmet>
            <Modal contentLabel="Create an AI Privacy Management Rule"
                   isOpen={modalIsOpen}
                   onRequestClose={() => {
                       resetCreateModal()
                   }}
                   shouldCloseOnOverlayClick={true}
                   className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white w-xl max-w-xl inset-y-10 mx-auto rounded-2xl`}
                   overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll"
            >
                <form className="flex flex-1 flex-col p-8 w-full ml-4 mr-4" onSubmit={handleSubmit(createAIManagementRule)}>
                    <div className="flex flex-1 flex-col">
                        {/*Title with exit button*/}
                        <div className="flex flex-row justify-between">
                            <h1 className="font-bold text-3xl">Create AI Management Rule</h1>
                            <MuiCloseIconButton
                                onClick={() => {
                                    resetCreateModal()
                                }}
                            />
                        </div>
                        <hr className="mt-3 h-0.5" />
                        {/*Form content*/}
                        <div className="ml-1 mt-5">
                            <label>Select which group to add to</label>
                            <MuiAutocompleteForZenGroupsWithoutCreateGroupOption
                                zenGroupDropdownOptionsList={getZenGroupDropDownContents()}
                                value={createAIZenGroupSelected}
                                onChange={( event, value ) => {
                                    setCreateAIZenGroupSelected(value?.value)
                                }}
                            />
                        </div>
                        <div className={"ml-1 mt-5 flex flex-row w-full gap-x-10 justify-between flex-nowrap items-end"}>
                            <div className={`w-full`}>
                                <label>AI Privacy Variant</label>
                                <MuiAutocompleteNonGroupOptions
                                    options={["Copilot", "ChatGPT", "Claude", "Genspark", "Comet", "Maxathon"]}
                                    value={aiFirewallVariantSelected}
                                    onChange={(event, value) => {
                                        setAiFirewallVariantSelected(value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className={"ml-1 mt-5 flex flex-row w-full gap-x-10 justify-between flex-nowrap items-end"}>
                            <div className={`w-full`}>
                                <label>Report Mode</label>
                                <MuiAutocompleteNonGroupOptions
                                    options={[reportModeFollowGroupText, reportModeAlwaysNotifyText, reportModeAlwaysBlockText]}
                                    value={aiFirewallReportModeSelected}
                                    onChange={(event, value) => {
                                        setAiFirewallReportModeSelected(value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className={"ml-1 mt-5 flex flex-row w-full gap-x-10 justify-between flex-nowrap items-end"}>
                            <div className={`w-full`}>
                                <label>AI Tool Enforcement</label>
                                <MuiAutocompleteNonGroupOptions
                                    options={[reportModeEnforceBothText, reportModeEnforceDesktopText, reportModeEnforceBrowserText]}
                                    value={aiToolEnforcement}
                                    onChange={(event, value) => {
                                        setAiToolEnforcement(value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className={"ml-1 mt-5 flex flex-row w-full flex-nowrap items-center"}>
                            <ThemeProvider theme = {switchTheme}>
                                {/*REAC-1223: preventing the AI variant process from running is coming soon, so the toggle is greyed out and stays off*/}
                                <FormControlLabel disabled control={
                                    <Switch
                                        checked={aiPreventUsageToggled}
                                        name="aiPreventUsageToggles"
                                        onChange={e => setAiPreventUsageToggled(e.target.checked)}
                                    />
                                } label={aiPreventUsageToggled ? "Prevent the AI Variant Process from Running" : "Select Protections for the AI Variant"}/>
                            </ThemeProvider>
                            <MuiIconWithTooltip
                                icon={
                                    <FontAwesomeIcon
                                        className="object-contain mt-1 cursor-pointer"
                                        icon="fa-light fa-circle-info"
                                        size="lg"
                                    />
                                }
                                tooltipTitle={`The feature to be able to completely prevent the ai variant process from running is coming soon. For now, you must still select the specific protections you want for this ai variant`}
                                tooltipPlacement={"bottom-start"}
                            />
                        </div>
                        <div className={`${aiPreventUsageToggled ? "hidden" : "block"} ml-1 mt-5 flex flex-col`}>
                            <label>Protections:</label>
                            <div key={"selectAllProtections"} className="ml-2 mt-5 flex flex-row">
                                <input
                                    className="mr-2 cursor-pointer"
                                    type="checkbox"
                                    checked={aiProtectionsChecked.length >= aiProtectionTypes.length}
                                    onChange={(event) => {
                                        let currentChecked = !event.target.checked
                                        if(currentChecked){
                                            //currently select all checked, need to deselect all
                                            setAiProtectionsChecked([])
                                        }
                                        else{
                                            //currently select all not checked, need to select all
                                            let allValues = []
                                            aiProtectionTypes.forEach(protection => {
                                                allValues.push(protection.value)
                                            })
                                            setAiProtectionsChecked(allValues)
                                        }
                                    }}

                                />
                                <label>Select All</label>
                            </div>
                            {aiProtectionTypes.map(({value, label}) => {
                                return (
                                    <div key={value} className="ml-5 mt-5 flex flex-row">
                                        <input
                                            className="mr-2 cursor-pointer"
                                            type="checkbox"
                                            checked={aiProtectionsChecked.includes(value)}
                                            onChange={(val) => {
                                                let selectedTypesArray = aiProtectionsChecked.slice();
                                                if(selectedTypesArray.includes(value)){
                                                    let index = selectedTypesArray.indexOf(value);
                                                    selectedTypesArray.splice(index, 1);
                                                    setAiProtectionsChecked(selectedTypesArray);
                                                }
                                                else{
                                                    selectedTypesArray.push(value);
                                                    setAiProtectionsChecked(selectedTypesArray);
                                                }
                                            }}

                                        />
                                        <label>{label}</label>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="flex flex-1 flex-col mt-5">
                            <ThemeProvider theme = {buttonTheme}>
                                <Button variant={"contained"}
                                        color={"primary"}
                                        type={"submit"}
                                >
                                    Create
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>

                </form>
            </Modal>
            <div className="flex flex-1 flex-col flex-nowrap gap-y-3 h-full">
                    {privatePageHeaderHelper("AI Privacy Management")}
                    <hr className="h-0.5" />
                    <DisplayOptions useFilterStateSettingToggled={useFilterStateSettingToggled}
                                    setUseFilterStateSettingToggled={setUseFilterStateSettingToggled}
                                    toggleUpdateUseFilterState={toggleUpdateUseFilterState}
                                    useColumnStateSettingToggled={useColumnStateSettingToggled}
                                    setUseColumnStateSettingToggled={setUseColumnStateSettingToggled}
                                    toggleUpdateUseColumnState={toggleUpdateUseColumnState} />
                    <div className="flex flex-row justify-between gap-x-1 gap-y-3">
                        <div className={"self-end flex flex-col gap-y-3"}>
                            <div className="flex flex-row justify-start gap-x-6 flex-wrap gap-y-2">
                                <MuiIconButtonWithTooltipAndBox
                                    icon={<PersonAddAlt1Icon className={"cursor-pointer"}/>} tooltipTitle={"Create an AI Management Rule. Note that creating a rule here will use only these rules for the selected ai variant, in " +
                                    "other words it will override any existing rules for the selected ai variant"}
                                    tooltipPlacement={"top"}
                                    onClick={() => {
                                        resetCreateModal()
                                        setModalIsOpen(true)
                                    }}/>
                                <MuiIconButtonWithTooltipAndBox
                                    icon={<DeleteIcon className={"cursor-pointer"}/>} tooltipTitle={"Delete AI Protection"}
                                    tooltipPlacement={"top"} disabled={!enableButtons}
                                    onClick={() => {
                                        if(gridApi && gridApi.getSelectedNodes() && gridApi.getSelectedNodes().length > 0){
                                            //loop through all the nodes
                                            setIsLoading(true)
                                            for (let i in gridApi.getSelectedNodes()){
                                                let aiPolicyToDelete = gridApi.getSelectedNodes()[i] //only allowing single selection on this page, so grab first element
                                                if(aiPolicyToDelete && aiPolicyToDelete.data && aiPolicyToDelete.data.zenGroupId
                                                    && aiPolicyToDelete.data.aiFirewallVariant && aiPolicyToDelete.data.aiFirewallProtection){
                                                    //Have to figure out what to send to endpoint to delete since we don't have the typical IDs
                                                    deleteAIFirewallPolicy(aiPolicyToDelete.data.zenGroupId, aiPolicyToDelete.data.aiFirewallVariant, aiPolicyToDelete.data.aiFirewallProtection).then(response => {
                                                        gridApi.applyTransactionAsync({
                                                            remove: [aiPolicyToDelete.data]
                                                        })
                                                    }).catch(function(error){})
                                                }
                                            }

                                            // successfully removed all
                                            setIsLoading(false)
                                            NotificationManager.success("AI Protection(s) successfully removed for groups you have permission in");
                                        }
                                    }}>
                                </MuiIconButtonWithTooltipAndBox>
                            </div>
                        </div>
                        <div className={"flex flex-row flex-wrap gap-y-3 gap-x-8 self-end justify-end"}>
                            <ClickToShowColumnOptionsWithToggleButtonGroup
                                columnMode={columnMode} setColumnMode={setColumnMode} gridColumnStateSessionVariableName={gridColumnStateSessionVariableName} gridApi={gridApi}
                                disableMediumOption={true} disableMinOption={true} updateGridColumnModeFunction={null} />
                            <ClearRefresh gridApi = {gridApi} showRefreshIcon={false} sseDataPullActive={sseDataPullActive}
                                          showExcelExportIcon={true}
                                          excelExportFunction = {excelExport} />
                        </div>
                    </div>
                    <div className="h-full flex flex-col gap-y-5" id="gridRoot">
                        {getGrid()}
                    </div>
                </div>
        </div>
    );


    function toggleUpdateUseFilterState(toggleSetting){
        updateUseFilterStateHelper(toggleSetting, gridFilterStateSessionVariableName, null);
    }
    function toggleUpdateUseColumnState(toggleSetting){
        updateUseColumnStateHelper(toggleSetting, gridColumnStateSessionVariableName, null);
    }

    function getGrid(){
        return (
            <Grid
                columnDefs={columnDefs}
                sideBar={sideBar}
                rowSelection={rowSelection}
                defaultColDef={defaultColDef}
                setGridApi={setGridApi}
                sseDataPullActive={sseDataPullActive}
                setSSEDataPullActive={setSSEDataPullActive}
                setEnableButtons={setEnableButtons}
                asyncTransactionWaitMillis={asyncTransactionWaitMillis}
                setAsyncTransactionWaitMillis={setAsyncTransactionWaitMillis}
                excelExport={excelExport}
                columnMode={columnMode}
                setColumnMode={setColumnMode}
            />
        );
    }

    function excelExport(){
        standardExcelExportHelper(gridApi, sseDataPullActive, "aiManagementGridExport")
    }
}

class Grid extends Component {
    rowData = []
    updateTransactionsToApply = []
    abortController = new AbortController()

    constructor(props, filterVals) {
        super(props);
    }
    onFirstDataRendered = (params) => {

    };
    onColumnStateChanged = (params) => {
        //function to handle when column state changes: sort change, column visibility changes, or a column position on grid is moved
        if(params.source !== "api" && params.source !== "gridOptionsChanged"){
            this.props.setColumnMode && this.props.setColumnMode(customColumnModeText)
            onColumnStateChangedHelper(params, gridColumnStateSessionVariableName, null) //TODO: Change to real endpoint to change col state
            updateColumnModeInSessionHelper(gridColumnStateSessionVariableName, null, customColumnModeText) //TODO: Change to real endpoint to change col state
        }
        else if(params.source === "api" && params.type === "sortChanged"){
            this.props.setColumnMode && this.props.setColumnMode(customColumnModeText)
            onColumnStateChangedHelper(params, gridColumnStateSessionVariableName, null) //TODO: Change to real endpoint to change col state
            updateColumnModeInSessionHelper(gridColumnStateSessionVariableName, null, customColumnModeText) //TODO: Change to real endpoint to change col state
        }
    }
    onCellEditingStopped = (event) => {
        let gridApi = event.api
        if(event.column.colId === "zenGroupDisplayName"){
            handleGroupColumnChangeNameOnly(event)
        }

    }

    componentWillUnmount(){
        this.abortController.abort()
    }

    populateGrid = async (rowData) => {
        standardHandlePopulateGrid(rowData, this.gridApi)
    }

    updateGridForChangeStream = async (changeStreamData) => {
        let operationType = changeStreamData.operationType
        let objectBody = changeStreamData.body
        if(operationType === "UPDATE" || operationType === "REPLACE"){
            standardHandleUpdateAndReplaceEvent(objectBody, this.gridApi, this.props.sseDataPullActive, this.updateTransactionsToApply)
        }
        else if (operationType === "INSERT"){
            standardHandleInsertEvent(objectBody, this.gridApi, this.props.sseDataPullActive)
        }
    }

    getRowId = (params) => {
        //No specific id given, so just combine the elements
        return `${params.data.zenGroupId}${params.data.aiFirewallVariant}${params.data.aiFirewallProtection}`
    }

    getContextMenuItems = (params) => {
        let excelExport = this.props.excelExport //don't have access to this.props below in the action function so define it here
        return [
            standardExcelExportObjectInContextMenu(excelExport),
            "resetColumns",
            "autoSizeAll"
        ];
    };

    onGridReady = async (gridReadyParams) => {
        this.gridApi = gridReadyParams.api;
        this.props.setGridApi(gridReadyParams.api);
        // Disable text selection on the page while holding shift or control (to allow grid selections to be done easily without selecting all text)
        ["keyup","keydown"].forEach((event) => {
            window.addEventListener(event, (e) => {
                document.onselectstart = function() {
                    return !(e.shiftKey || e.ctrlKey);
                }
            });
        });
        //Only max/custom are allowed for this grid
        let columnMode = this.props.columnMode
        //check which initial column mode to apply
        if(columnMode === customColumnModeText){
            onGridReadyHelperForColumnState(gridReadyParams, gridColumnStateSessionVariableName)
        }
        //else if columnMode is max then the default column state already shows the max amount of columns no need to update

        onGridReadyHelper(gridReadyParams, gridFilterStateSessionVariableName);

        await loadDataWithSSEAndStartChangeStreamListener("/getAIFirewallPolicies", null,
            this.populateGrid, null, gridReadyParams, this.props.setSSEDataPullActive, this.props.setAsyncTransactionWaitMillis, this.updateTransactionsToApply,
            this.abortController)
        //gridReadyParams.api.sizeColumnsToFit()
    };
    render() {
        return (
            <div className={"w-full h-full"} style={{minHeight: "400px"}}>
                <div id="myGrid" className="ag-theme-alpine rounded-md shadow h-full w-full">
                    <AgGridReact
                        columnMenu={"legacy"}
                        modules={[
                            ClientSideRowModelModule,
                            AllCommunityModule,
                            ColumnMenuModule,
                            ContextMenuModule,
                            ColumnsToolPanelModule,
                            SetFilterModule,
                            ExcelExportModule,
                            CsvExportModule
                        ]}
                        defaultColDef={this.props.defaultColDef}
                        columnDefs={this.props.columnDefs}
                        components={{agDateInput: DTPicker, customNameCellEditor: CustomNameCellEditor}}
                        multiSortKey={"ctrl"}
                        rowData={this.rowData}
                        onGridReady={this.onGridReady}
                        asyncTransactionWaitMillis={this.props.asyncTransactionWaitMillis}
                        suppressModelUpdateAfterUpdateTransaction={true}
                        getRowId={this.getRowId}
                        onCellEditingStopped={this.onCellEditingStopped}
                        maintainColumnOrder={true} //fixes issue where if you re-order/move column then click anywhere on the grid it reverts this change
                        rowSelection={this.props.rowSelection}
                        onSelectionChanged={() => {
                            const selectedRows = this.gridApi.getSelectedRows();
                            if(selectedRows && selectedRows.length > 0){
                                //checks if the setEnableButtons method is null or not
                                this.props.setEnableButtons && this.props.setEnableButtons(true);
                            }
                            else{
                                this.props.setEnableButtons && this.props.setEnableButtons(false);
                            }
                        }}
                        enableCellTextSelection={true}
                        ensureDomOrder={true}
                        onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                        onFilterChanged={(params)=> {
                            //TODO: Change
                            onFilterChangedHelper(params, gridFilterStateSessionVariableName, null);
                        }}
                        //columnState listeners
                        onSortChanged={this.onColumnStateChanged}
                        onColumnMoved={this.onColumnStateChanged}
                        onColumnVisible={this.onColumnStateChanged}
                        getContextMenuItems={this.getContextMenuItems}
                        sideBar={this.props.sideBar}
                    />
                </div>
            </div>
        );
    }
}
